import { defineMessages } from 'react-intl'

export default defineMessages({
  contacts: {
    id: 'containers.CustomerTeamPage.Team.contacts',
    defaultMessage: 'Producers',
  },
  back: {
    id: 'containers.CustomerTeamPage.Team.back',
    defaultMessage: 'Back',
  },
  edit: {
    id: 'containers.CustomerTeamPage.Team.edit',
    defaultMessage: 'Edit',
  },
  finish: {
    id: 'containers.CustomerTeamPage.Team.finish',
    defaultMessage: 'Finish',
  },
})
